import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import TicketCategoriesList from './TicketCategoriesList'

export default function TicketCategories() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/ticket_categories" component={TicketCategoriesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}